export function fetchPosts(count, contentUid, offset = 0, render = false) {
    const url = new URLSearchParams();
    url.append('type', '1652965829');
    url.append('tx_c3social_ajaxpost[count]', count.toString());
    url.append('tx_c3social_ajaxpost[offset]', offset.toString());
    url.append('tx_c3social_ajaxpost[render]', render ? '1' : '0');
    url.append('tx_c3social_ajaxpost[contentUid]', contentUid.toString());

    return fetch(`/?${url.toString()}`, {
        method: 'GET',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        }
    });
}